import React, { useState } from "react";
import GeniePage from "../../../components/special/genie-page/GeniePage";
import GenieStickyHeader from "../../../components/core/genie-sticky-header/GenieStickyHeader";
import {
  Button,
  Chip,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import GenieText from "../../../components/core/genie-text/GenieText";
import { useParams } from "react-router-dom";
import useInvites from "../../../queries/routes/useInvites";
import Box from "@mui/material/Box";
import { readableDateTime } from "../../../utils/date";
import GenieTableLoad from "../../../components/core/genie-table-load/GenieTableLoad";
import GenieEmpty from "../../../components/core/genie-empty/GenieEmpty";
import InviteDialog from "../onboarding/dialogs/Invite";
import useRetryInvite from "../../../queries/routes/useRetryInvite";

function Invites() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { org_id } = useParams();
  const { data, isLoading } = useInvites(org_id!);
  const { mutate: retryInvite, isLoading: isLoadingRetryInvite } =
    useRetryInvite();

  function setClosed() {
    setDialogOpen(false);
  }

  return (
    <GeniePage noMargin>
      <InviteDialog open={dialogOpen} setClosed={setClosed} />
      <GenieStickyHeader>
        <Stack
          flexDirection={"row"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <GenieText fontSize={"medium"} fontWeight={"bold"}>
            Invites
          </GenieText>
          <Button variant={"outlined"} onClick={() => setDialogOpen(true)}>
            Invite
          </Button>
        </Stack>
      </GenieStickyHeader>
      <TableContainer component={Box}>
        {isLoading ? (
          <GenieTableLoad
            rowCount={10}
            columnCount={3}
            sx={{ minWidth: 650 }}
          />
        ) : data && data.length === 0 ? (
          <GenieEmpty>Invites to customers haven't been sent yet</GenieEmpty>
        ) : (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Email</TableCell>
                <TableCell align="left">Invited On</TableCell>
                <TableCell align="left">Accepted On</TableCell>
                <TableCell align="left">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{row.send_to_email}</TableCell>
                    <TableCell align="left">
                      {readableDateTime(row.created_on)}
                    </TableCell>
                    <TableCell align="left">
                      {row.accepted_on ? (
                        readableDateTime(row.accepted_on)
                      ) : (
                        <Chip
                          variant={"outlined"}
                          label={"Not Accepted"}
                          color={"warning"}
                        />
                      )}
                    </TableCell>
                    <TableCell align={"left"}>
                      {!row.accepted_on && (
                        <Button
                          disabled={isLoadingRetryInvite}
                          onClick={() =>
                            retryInvite(row.id, {
                              onSuccess: () => {
                                setSnackbarOpen(true);
                              },
                            })
                          }
                          size={"small"}
                        >
                          Resend
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        message="Invite Resent!"
      />
    </GeniePage>
  );
}

export default Invites;
